import React from 'react'
import Pagination from './list'

const RecordPagination = ({
    offset,
    limit,
    total,
    setOffset = () => {}
}) => {
    if( !total || !limit || total <= limit ) {
        return null
    }

    const totalPages = Math.ceil(total / limit)
    const currentPage = Math.floor(offset / limit) + 1
    const setCurrentPage = (page) => {
        setOffset(( page - 1) * limit)
    }
    return (<Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />)
}

export default RecordPagination